export default __webpack_public_path__ + "static/mosaic_anim-1d8ccec5d91e4d04ae04d32f9ff21d84.mp4";